import { useStore } from 'vuex'
import {ref, computed, onMounted} from 'vue'
import DeliveryCard from 'components/DeliveryCard/DeliveryCard.vue'
import { mapBasketItemToGa4, trackAddShippingInfo } from 'foundation/js/ecommerceTracking'
import DeliveryAddress from 'components/DeliveryAddress/DeliveryAddress.vue'
import PickUpAddress from 'components/PickUpAddress/PickUpAddress.vue'
import { checkoutScrollToTop } from '../CheckoutContent/CheckoutScrollToTop'

export default {
    name: "CheckoutStepTwo",
    components: {DeliveryCard, DeliveryAddress, PickUpAddress},
    props: {
        onSubmitCallback: {
            type: Function,
            required: false
        }
    },
    setup(props) {
        const store = useStore()

        onMounted(() => {
            store.dispatch('basket/fetchBasket')
            checkoutScrollToTop()
        })

        const displayInputErrors = ref(false)

        const getLabel = (labelKey)=> store.getters['labels/getLabel']({labelCollection: 'checkout', labelKey: labelKey})

        const isSubmitting = computed(()=> store.state.checkout.isSubmitting)
        
        const checkoutSteps = computed( () => store.state.checkout.checkoutSteps)
        const currentStep = computed( () => checkoutSteps.value.find(i => i.stepNumber === 2))
        const beenFilled = computed(()=> currentStep.value.beenFilled)
        
        // use beenFilled to access whether step data is in sessionStorage, then make unSubmitted false only if it has
        const unSubmitted = ref(beenFilled.value ? false : true)
        const isStepSubmitting = computed(()=> !unSubmitted.value)

        const showDifferentAddress = computed( () => store.state.checkout.stepTwo.showDifferentAddress)
        const showPickUpAddresses = computed( () => store.state.checkout.stepTwo.showPickUpAddresses)

        const deliveryDataValidationSuccess = computed( () => store.state.checkout.stepTwo.deliveryDataValidationSuccess)
        
        const activeDeliveryAddress = computed( () => store.state.checkout.stepTwo.activeDeliveryAddress)
        
        const differentAddressData = computed( () => store.state.checkout.stepTwo.differentAddressData)
        const pickUpAddressData = computed( () => store.state.checkout.stepTwo.pickUpAddressData)

        const activeDeliveryAddressData = computed(()=> {
            if(showPickUpAddresses.value) {
                return pickUpAddressData.value
            } 
            if (showDifferentAddress.value) {
                return differentAddressData.value
            } 
            
            return activeDeliveryAddress.value
            
        })

        const onSubmit = function() {
            unSubmitted.value = false
            displayInputErrors.value = true
            
            const checkoutDeliveryPayload = activeDeliveryAddressData.value

            if (props.onSubmitCallback) {
                props.onSubmitCallback(
                    deliveryDataValidationSuccess.value ? checkoutDeliveryPayload : null
                )
            } else {
                if (!deliveryDataValidationSuccess.value)
                    return false
                
                store.commit('checkout/set_purchase_data_delivery', checkoutDeliveryPayload)

                // update the active delivery address (initially is set to invoice address)
                store.commit('checkout/set_active_delivery_address', checkoutDeliveryPayload)

                const shippingTier = showPickUpAddresses.value ? 'Afhentningssted' : 'Hjemmelevering'
                const items = store.state.basket.basket
                trackAddShippingInfo(items.map((item, index) => mapBasketItemToGa4(item, index)), shippingTier)

                // if succes set step to next stepNumber
                store.commit('checkout/update_checkout_step',{nextStepNumber: 3})
            }
        }
    
        return {
            onSubmit,
            isSubmitting,
            isStepSubmitting,
            getLabel,
            displayInputErrors,
            showDifferentAddress,
            showPickUpAddresses,
            toStepOne: () => store.commit('checkout/update_checkout_step',{nextStepNumber: 1})
        }
        
    }
}